module.exports = __webpack_public_path__ + "static/img/icon_wfjf.b6c8cac7.png";